module.exports = __webpack_public_path__ + "img/live-event.8e28c036.svg";